<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">保养日期：</span>
        <el-date-picker
            v-model="search.time"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00','23:59:59']"
            range-separator="-"
            start-placeholder="起始时间"
            end-placeholder="结束时间">
        </el-date-picker>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="insertProp">新增</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bigDeviceName" label="设备名称" align="center" width="150"></el-table-column>
        <el-table-column prop="bigDeviceModel" label="规格型号" align="center" ></el-table-column>
        <el-table-column prop="bigNumber" label="设备编号" align="center" ></el-table-column>
        <el-table-column prop="bigTypeName" label="设备类型" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="maintenanceNumber" label="保养编号" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="maintenanceTime" label="保养日期" align="center" width="150"></el-table-column>
        <el-table-column prop="realName" label="责任人" align="center" ></el-table-column>
        <el-table-column prop="responsibilityPhone" label="责任人电话" width="120" align="center" ></el-table-column>
        <el-table-column prop="situation" label="维护保养情况" align="center" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="maintenanceNotes" label="备注" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="记录时间" align="center" width="150"></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="updateProp(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle? '新增保养' :'修改保养'"
      :close-on-click-modal="false"
      :visible.sync="asyncVisible"
      width="45%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="设备名称：" prop="bigDeviceId">
          <el-select v-model="ruleForm.bigDeviceId" placeholder="请选择设备名称" clearable @change="changeBigDevice">
            <el-option
                v-for="item in optionsDevice"
                :key="item.bigDeviceId"
                :label="item.bigDeviceName"
                :value="item.bigDeviceId">
            </el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="规格型号：" prop="bigDeviceModel">
          <el-input v-model="ruleForm.bigDeviceModel" :size="size" clearable placeholder="请输入规格型号" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="设备编号：" prop="bigNumber">
          <el-input v-model="ruleForm.bigNumber" :size="size" clearable placeholder="请输入设备编号" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="设备类型：" prop="bigType">
          <el-select v-model="ruleForm.bigType" placeholder="请选择设备类型" :disabled="true">
                <el-option
                v-for="item in optionsType"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="保养编号：" prop="maintenanceNumber">
          <el-input v-model="ruleForm.maintenanceNumber" :size="size" clearable placeholder="请输入保养编号" ></el-input>
        </el-form-item>
        <el-form-item label="保养日期：" prop="maintenanceTime">
            <el-date-picker
                v-model="ruleForm.maintenanceTime"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择保养日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="责任人：" prop="responsibilityPeople">
          <el-select v-model="ruleForm.responsibilityPeople" placeholder="请选择责任人" @change="changePeople">
                <el-option
                    v-for="item in optionsUser"
                    :key="item.userId"
                    :label="item.realName"
                    :value="item.userId">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="责任人电话：" prop="responsibilityPhone">
          <el-input v-model="ruleForm.responsibilityPhone" :size="size" clearable placeholder="请输入责任人电话" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="维护保养情况：" prop="situation">
            <el-input v-model="ruleForm.situation" :size="size" type="textarea" :rows="2" clearable placeholder="请输入维护保养情况" ></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="maintenanceNotes">
            <el-input v-model="ruleForm.maintenanceNotes" :size="size" type="textarea" :rows="2" clearable placeholder="请输入备注" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import { throttle, changeSize } from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        dataList: [], //设备保养信息列表
        asyncTitle: true, // 对话框title 新增：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        ruleForm: {
        }, // 按钮表单
        rules: {
          bigDeviceId: [{
            required: true,
            message: '请输入设备名称',
            trigger: 'blur'
          }],
          bigDeviceModel: [{
            required: true,
            message: '请输入规格型号',
            trigger: 'blur'
          }],
          bigType: [{
            required: true,
            message: '请选择设备类型',
            trigger: 'change'
          }],
          bigNumber: [{
            required: true,
            message: '请输入设备编号',
            trigger: 'blur'
          }],
          maintenanceNumber: [{
            required: true,
            message: '请输入保养编号',
            trigger: 'blur'
          }],
          maintenanceTime: [{
            required: true,
            message: '请选择保养日期',
            trigger: 'change'
          }],
          responsibilityPeople:[{
            required: true,
            message: '请选择责任人',
            trigger: 'change'
          }],
          responsibilityPhone: [{
            required: true,
            message: '请输入联系电话',
            trigger: 'blur'
          },{
            pattern:
              /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }],
          situation: [{
            required: true,
            message: '请输入保养情况',
            trigger: 'blur'
          }],
        },
        optionsType:[],//设备类型
        optionsDevice:[],//设备名称
        optionsUser:[],//负责人
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchButtonInfo(true);
      that.getAllTypes()
      that.getAllDevices()
      that.getAllPersons()
    },
    methods: {
    //选择不同的人回显电话
    changePeople(val){
        this.$api.Engineer.getPersonsList({userId:val}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.$set(this.ruleForm,'responsibilityPhone',res.data[0].phone)
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
    },
    //获得所有人员
    getAllPersons(){
        this.$api.Engineer.getPersonsList({}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsUser = res.data
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
    },
    //改变设备名称带出不同的信息
    changeBigDevice(val){
        this.$api.Device.detailsBigDevice({bigDeviceId: val}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.$set(this.ruleForm,'bigDeviceModel',res.data.bigDeviceModel)
                this.$set(this.ruleForm,'bigType',res.data.bigType)
                this.$set(this.ruleForm,'bigNumber',res.data.bigNumber)
                this.$set(this.ruleForm,'bigPosition',res.data.bigPosition)
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
    },
    //获取大型设备下拉
    getAllDevices(){
        this.$api.Device.getAllBigDevice({}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsDevice = res.data
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
    },
    //获取设备类型
      getAllTypes(){
        let params = {
            pageNum: 1,
            pageSize: 100000000,
        }
        this.$api.Dictionary.searchDictionary(params).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsType = res.data.list.filter(item=>item.dictType ==='9')
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        params.strTime = this.search.time&&this.search.time[0]
        params.endTime = this.search.time&&this.search.time[1]
        delete params.time
        this.loading = true;
        this.$api.Device.searchKeepDevice(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 新增按钮信息
      insertProp() {
        this.asyncTitle = true;
        this.asyncVisible = true;
      },
      // 修改按钮信息
      updateProp(row) {
        this.asyncTitle = false;
        this.asyncVisible = true;
        this.$api.Device.detailsKeepDevice({bigMaintenanceId: row.bigMaintenanceId}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.ruleForm = res.data
                let inspectTypesArr = []
                res.data.inspectTypes.forEach(item=>{
                    inspectTypesArr.push(item.typeId)
                })
                this.$set(this.ruleForm,'typeIds',inspectTypesArr)
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 删除按钮信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Device.deleteKeepDevice({bigMaintenanceId: row.bigMaintenanceId})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchButtonInfo(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加按钮信息
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            this.$api.Device.insertKeepDevice(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改按钮信息
      submitUpdate: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            this.$api.Device.updateKeepDevice(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="sass" scoped>
@import '../../style/layout-main.scss';
</style>